export type Surfer = {
  rank: number;
  name: string;
  country: string;
  flag: string;
  points: number;
  events: number;
  bestResult: string;
  results: { event: string; place: number | "—" }[];
};

export const tourEvents2026 = [
  "Bells Beach",
  "Margaret River",
  "Gold Coast",
  "New Zealand",
  "El Salvador",
  "Rio Pro",
  "Tahiti",
  "Fiji",
  "Trestles",
  "Abu Dhabi",
  "Portugal",
  "Pipe Masters",
] as const;

const m = (results: (number | "—")[]): Surfer["results"] =>
  tourEvents2026.map((event, i) => ({ event, place: results[i] ?? "—" }));

// ─── REAL STANDINGS after Event 4 — New Zealand Pro, May 25 2026 ───────────
// Source: worldsurfleague.com / waves.com.br
// Next event: Surf City El Salvador Pro, Jun 5–15

export const menRankings: Surfer[] = [
  { rank: 1,  name: "Ítalo Ferreira",      country: "Brazil",       flag: "🇧🇷", points: 22725, events: 4, bestResult: "1st – New Zealand",   results: m(["—", "—", 9,  1,  "—","—","—","—","—","—","—","—"]) },
  { rank: 2,  name: "Miguel Pupo",         country: "Brazil",       flag: "🇧🇷", points: 21385, events: 4, bestResult: "3rd – Gold Coast",     results: m(["—", "—", 3,  5,  "—","—","—","—","—","—","—","—"]) },
  { rank: 3,  name: "Gabriel Medina",      country: "Brazil",       flag: "🇧🇷", points: 20525, events: 4, bestResult: "1st – Gold Coast",     results: m(["—", "—", 1,  9,  "—","—","—","—","—","—","—","—"]) },
  { rank: 4,  name: "Yago Dora",           country: "Brazil",       flag: "🇧🇷", points: 19630, events: 4, bestResult: "3rd – New Zealand",    results: m(["—", "—", 5,  3,  "—","—","—","—","—","—","—","—"]) },
  { rank: 5,  name: "George Pittar",       country: "Australia",    flag: "🇦🇺", points: 17640, events: 4, bestResult: "2nd – Gold Coast",     results: m(["—", "—", 2,  9,  "—","—","—","—","—","—","—","—"]) },
  { rank: 6,  name: "Ethan Ewing",         country: "Australia",    flag: "🇦🇺", points: 16745, events: 4, bestResult: "5th – Gold Coast",     results: m(["—", "—", 5,  9,  "—","—","—","—","—","—","—","—"]) },
  { rank: 7,  name: "Samuel Pupo",         country: "Brazil",       flag: "🇧🇷", points: 16575, events: 4, bestResult: "5th – Gold Coast",     results: m(["—", "—", 5,  9,  "—","—","—","—","—","—","—","—"]) },
  { rank: 8,  name: "Griffin Colapinto",   country: "USA",          flag: "🇺🇸", points: 16490, events: 4, bestResult: "3rd – New Zealand",    results: m(["—", "—", 9,  3,  "—","—","—","—","—","—","—","—"]) },
  { rank: 9,  name: "Leonardo Fioravanti", country: "Italy",        flag: "🇮🇹", points: 16130, events: 4, bestResult: "5th – New Zealand",    results: m(["—", "—", 9,  5,  "—","—","—","—","—","—","—","—"]) },
  { rank: 10, name: "Filipe Toledo",       country: "Brazil",       flag: "🇧🇷", points: 15150, events: 4, bestResult: "9th – Gold Coast",     results: m(["—", "—", 9,  9,  "—","—","—","—","—","—","—","—"]) },
];

export const womenRankings: Surfer[] = [
  { rank: 1,  name: "Gabriela Bryan",          country: "Hawaii, USA", flag: "🇺🇸", points: 24235, events: 4, bestResult: "1st – Margaret River", results: m(["—", 1,   5,  5,  "—","—","—","—","—","—","—","—"]) },
  { rank: 2,  name: "Luana Silva",             country: "Brazil",      flag: "🇧🇷", points: 22345, events: 4, bestResult: "2nd – Gold Coast",     results: m(["—", "—", 2,  9,  "—","—","—","—","—","—","—","—"]) },
  { rank: 3,  name: "Molly Picklum",           country: "Australia",   flag: "🇦🇺", points: 22035, events: 4, bestResult: "1st – Bells Beach",    results: m([1,   "—", 5,  9,  "—","—","—","—","—","—","—","—"]) },
  { rank: 4,  name: "Lakey Peterson",          country: "USA",         flag: "🇺🇸", points: 21490, events: 4, bestResult: "3rd – Gold Coast",     results: m(["—", "—", 3,  9,  "—","—","—","—","—","—","—","—"]) },
  { rank: 5,  name: "Sawyer Lindblad",         country: "USA",         flag: "🇺🇸", points: 20970, events: 4, bestResult: "2nd – New Zealand",    results: m(["—", "—", 9,  2,  "—","—","—","—","—","—","—","—"]) },
  { rank: 6,  name: "Carissa Moore",           country: "Hawaii, USA", flag: "🇺🇸", points: 18745, events: 4, bestResult: "1st – New Zealand",    results: m(["—", "—", 9,  1,  "—","—","—","—","—","—","—","—"]) },
  { rank: 7,  name: "Caitlin Simmers",         country: "USA",         flag: "🇺🇸", points: 17575, events: 4, bestResult: "1st – Bells Beach",    results: m([1,   "—", 9,  9,  "—","—","—","—","—","—","—","—"]) },
  { rank: 8,  name: "Bettylou Sakura Johnson", country: "Hawaii, USA", flag: "🇺🇸", points: 14830, events: 4, bestResult: "3rd – Bells Beach",    results: m([3,   "—", 9,  5,  "—","—","—","—","—","—","—","—"]) },
  { rank: 9,  name: "Alyssa Spencer",          country: "USA",         flag: "🇺🇸", points: 14170, events: 4, bestResult: "5th – Gold Coast",     results: m(["—", "—", 5,  9,  "—","—","—","—","—","—","—","—"]) },
  { rank: 10, name: "Stephanie Gilmore",       country: "Australia",   flag: "🇦🇺", points: 14000, events: 4, bestResult: "1st – Margaret River", results: m(["—", 1,   "—","—","—","—","—","—","—","—","—","—"]) },
];

export const rankingsMeta = {
  lastUpdated: "2026-05-25",
  afterEvent: 4,
  lastEventName: "Corona Cero New Zealand Pro",
  lastEventLocation: "Manu Bay, Raglan, New Zealand",
  nextEventName: "Surf City El Salvador Pro",
  nextEventWindow: "Jun 5 – 15, 2026",
  nextEventLocation: "Punta Roca, La Libertad, El Salvador",
};
